import * as tslib_1 from "tslib";
import React from 'react';
import { calculateColumnWidth } from '..';
const InlineHeaderClass = 'inlineheader';
/**
 * Responsive table cells
 */
export const ResponsiveTd = (_a) => {
    var { header, children, numColumns, columnWidth } = _a, props = tslib_1.__rest(_a, ["header", "children", "numColumns", "columnWidth"]);
    return (React.createElement("td", Object.assign({}, props, { style: Object.assign({ width: columnWidth ? columnWidth : calculateColumnWidth(numColumns) }, props.style) }),
        React.createElement("div", { className: InlineHeaderClass }, header),
        children || React.createElement("div", null, "\u00A0")));
};
export const ResponsiveTdMemo = React.memo(ResponsiveTd);
//# sourceMappingURL=Responsive.js.map